import { render } from "./new.vue?vue&type=template&id=e2c3162c&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"

import "./new.vue?vue&type=style&index=0&id=e2c3162c&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\agent-yuyooke\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c3162c"]])

export default __exports__